<template >
  <card-seplag titulo="Agendamento de Férias">
    <Card v-if="bloqueiaAgendamento" class="p-col-12">
      <!-- redmine #22247 -->
      <template #content>
        <p class="p-text-center">
          O agendamento de férias de {{ descVinculo }} não está disponível por meio do Portal do Servidor. 
          O controle e a programação das férias de {{ descVinculo }} são realizados diretamente pela unidade setorial de gestão de pessoas do seu órgão.
        </p>
      </template>
    </Card>    
    <Card v-if="!habilitaAgendamento && !bloqueiaAgendamento" class="p-col-12">
      <template #content>
        <p class="p-text-center">
          Solicitação de Ferias Desabilitado Temporariamente, se necessário
          entre em contato com a Gestão de Pessoas do seu setor.
        </p>
      </template>
    </Card>
    <Rotulo cols="12 4" v-if="habilitaAgendamento && !bloqueiaAgendamento">
      <Fieldset legend="Selecione um período aquisitivo:">
        <Rotulo nome="Período(s) aquisitivo(s) com saldo">
          <Dropdown
            v-model="selectedPeriodoAquisitivo"
            :options="periodosAquisitivos"
            optionLabel="descPeriodo"
            placeholder="Selecione um período"
            :filter="false"
            :showClear="true"
            @input="carregarCamposAgendamento()"
            :disabled="!habilitarSelecaoPeriodo"
          />
        </Rotulo>

        <Rotulo nome="Saldo de dias de direito">
          <InputText
            type="button"
            disabled="true"
            v-model="saldoDias"
            id="input_mostra_dias"
          />
        </Rotulo>
      </Fieldset>
    </Rotulo>
    <Rotulo cols="12 8">
      <Fieldset
        legend="Selecione a quantidade de dias pretendidos:"
        v-if="tiposGozo && tiposGozo.length > 0"
      >
        <SelectButton
          v-model="selectedTipoGozo"
          :options="tiposGozo"
          optionLabel="name"
          @input="calcularData()"
          d
        />
        <br /><br />
        <div
          class="p-grid"
          v-if="selectedTipoGozo && selectedTipoGozo.code != null"
        >
          <Rotulo cols="12 2" style="margin-top: 1.8%">
            <div
              style="
                background-color: #b7d8b7;
                text-align: center;
                padding: 6px;
              "
              v-if="selectedTipoGozo && selectedTipoGozo.code == 10"
            >
              <b>10</b> dias corridos
            </div>
            <div
              style="
                background-color: #7fbcec;
                text-align: center;
                padding: 6px;
              "
              v-if="selectedTipoGozo && selectedTipoGozo.code == 15"
            >
              <b>15</b> dias corridos
            </div>
            <div
              style="
                background-color: #ffe399;
                text-align: center;
                padding: 6px;
              "
              v-if="selectedTipoGozo && selectedTipoGozo.code == 20"
            >
              <b>20</b> dias corridos
            </div>
            <div
              style="
                background-color: #f8b7bd;
                text-align: center;
                padding: 6px;
              "
              v-if="selectedTipoGozo && selectedTipoGozo.code == 30"
            >
              <b>30</b> dias corridos
            </div>
          </Rotulo>
          <Rotulo nome="Data de início" id="integral_inicio" cols="12 5">
            <v-date-picker
              v-model="data_inicio"
              @input="calcularData()"
              :max-date="max_date"
              :min-date="min_date"
              :model-config="datePikerConfig"
              :first-day-of-week="1"
              :update-on-input="false"
              :masks="datePikermasks"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="p-inputmask p-inputtext p-component"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </v-date-picker>
            <!-- <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="data_inicio" @input="calcularData()" /> -->
            <!-- <Calendar :showIcon="true" v-model="data_inicio" dateFormat="dd/mm/yy" @input="calcularData()" /> -->
          </Rotulo>
          <Rotulo nome="Data de término" id="integral_fim" cols="12 4">
            <InputMask
              mask="99/99/9999"
              placeholder="dd/mm/aaaa"
              v-model="data_fim"
              disabled="true"
            />
            <!-- <Calendar   :showIcon="true" dateFormat="dd/mm/yy" v-model="data_fim" /> -->
          </Rotulo>
          <Rotulo
            nome="Agendar"
            cols="12 1"
            style="text-align: center"
            v-if="habilitarSelecaoPeriodo"
          >
            <Button
              type="button"
              icon="pi pi-check"
              class="p-button-info"
              @click="adicionarRegistro()"
            />
          </Rotulo>
          <Rotulo nome="Alterar" cols="12 1" style="text-align: center" v-else>
            <Button
              type="button"
              icon="pi pi-pencil"
              class="p-button-warning"
              @click="atualizarRegistro()"
              v-tooltip.top="'Atualizar'"
            />
            <Button
              type="button"
              icon="pi pi-times"
              class="p-button-danger margimLeft"
              @click="cancelarAlteracao()"
              v-tooltip.top="'Cancelar Edição'"
            />
          </Rotulo>
        </div>
        <div class="p-grid" v-else>
          <h3>Selecione a Quantidade de Dias Pretendidos.</h3>
        </div>
      </Fieldset>
    </Rotulo>
    <div class="p-col-12">
      <DataTable
        :value="agendamentos"
        :paginator="true"
        :rows="10"
        responsiveLayout="scroll"
        class="p-datatable-responsive table-seplag"
      >
        <Column
          field="periodoAquisitivo"
          header="Período Aquisitivo"
          :headerStyle="`width: 3%;`"
        ></Column>
        <Column
          field="totdias"
          header="Dias solicitados"
          :headerStyle="`width: 3%;`"
        ></Column>
        <Column field="dataInicio" header="Data Início"></Column>
        <Column field="dataFim" header="Data Término"></Column>
        <Column
          field="statusFerias"
          header="Situação"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <Button
              :class="'p-button-text status-' + slotProps.data.statusFerias"
              type="button"
              @click="showModalJustificativa(slotProps.data)"
              :label="
                slotProps.data.statusFerias == 'VIASEAP'
                  ? 'SEAP'
                  : slotProps.data.statusFerias
              "
              v-tooltip.top="
                slotProps.data.obs
                  ? 'Ver Justificativa'
                  : 'Não Possui Justificativa'
              "
            />
          </template>
        </Column>
        <Column field="aprovador" header="Aprovador">
          <template #body="slotProps">
            <div class="colunaAprovador">
              <span>{{ slotProps.data.aprovadorLabel }}</span
              ><br />
              <span>{{ slotProps.data.aprovadorUnidade }}</span>
            </div>
          </template>
        </Column>
        <Column field="origem" header="" v-if="habilitaAgendamento">
          <template #body="slotProps">
            <Button
              v-if="
                slotProps.data.statusFerias != 'FINALIZADO' &&
                slotProps.data.origem != 'SEAP' &&
                slotProps.data.statusFerias != 'REPROVADO'
              "
              class="p-button-warning"
              type="button"
              icon="pi pi-pencil"
              @click="showModalTermo(slotProps.data)"
              v-tooltip.top="'Editar'"
            />
          </template>
        </Column>
      </DataTable>
    </div>
    <cadastro-rapido
      tituloTela="Justificativa"
      :tamanhoTela="'30.vw'"
      v-model="exibirTelJustificativa"
      textoButtonFechar="Fechar"
      :visivelbotao="true"
    >
      <p
        style="text-align: justify"
        v-html="
          justificativaSelecionada ? justificativaSelecionada : 'Não Informado'
        "
      />
    </cadastro-rapido>
    <cadastro-rapido
      tituloTela=" "
      :tamanhoTela="'50.vw'"
      v-model="exibirTelTermo"
      textoButtonFechar="Fechar"
      :visivelbotao="false"
    >
      <div class="containerTermo">
        <p class="textoTermo" v-html="termo ? termo : 'Não Informado'" />
        <div class="containerButtonTermo">
          <Button
            type="button"
            icon="pi pi-pencil"
            class="p-button-warning"
            @click="abrirEdicaoFerias()"
            v-tooltip.top="'Ciência'"
            label="Ciente"
          />
          <Button
            type="button"
            icon="pi pi-times"
            class="p-button-danger margimLeft"
            @click="fecharModalAlteracao()"
            v-tooltip.top="'Cancelar'"
            label="Cancelar"
          />
        </div>
      </div>
    </cadastro-rapido>
  </card-seplag>
</template>
<script>
import CardSeplag from "@/template/CardSeplag.vue";
// import TableSeplag from '@/template/TableSeplag.vue' TableSeplag,
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
import moment from "moment";

export default {
  name: "agendamentoFeriasServidor",
  components: { CardSeplag, CadastroRapido, Rotulo },
  data() {
    return {
      modoEdicao: "adicionar",
      apiUrlRecurso: "direitoafastamentos",
      saldoDias: 0,
      selectedPeriodoAquisitivo: null,
      periodosAquisitivos: [],
      agendamentos: [],
      data_inicio: moment().format('DD/MM/YYYY'),
      data_inicio_agendamento: moment().format('DD/MM/YYYY'),
      max_date: null,
      min_date: moment().format(),
      data_fim: null,
      selectedTipoGozo: { name: null, code: null },
      tiposGozo: [],
      datePikerConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },

      datePikermasks: {
        input: "DD/MM/YYYY",
      },
      habilitaAgendamento: false,
      habilitarSelecaoPeriodo: true,
      totalRecords: 0,
      exibirTelJustificativa: false,
      justificativaSelecionada: null,
      parametro: null,
      termo: "",
      exibirTelTermo: false,
      feriasSelecionado: null,
      nomeServidor: "",
      nomeUnidade: "",

      //redmine #22247
      descVinculo: null,
      bloqueiaAgendamento: true,
    };
  },
  methods: {
    limparDados() {
      (this.selectedTipoGozo = { name: null, code: null }),
        (this.tiposGozo = []),
        (this.selectedPeriodoAquisitivo = null),
        (this.periodosAquisitivos = []),
        (this.agendamentos = []),
        (this.data_inicio = moment().format('DD/MM/YYYY')),
        (this.data_fim = null);
    },
    fecharModalAlteracao() {
      this.exibirTelTermo = false;
    },
    cancelarAlteracao() {
      this.limparDados();
      this.habilitarSelecaoPeriodo = true;
      this.exibirTelTermo = false;
      this.carregarDados();
    },
    calcularData() {
      if (this.selectedTipoGozo) {
        if (this.data_inicio) {
          let checkData = this.data_inicio.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("/", "");
          checkData = checkData.replace("/", "");
          checkData = checkData.split("");
          if (checkData.length > 7) {
            let data_i = new moment(this.data_inicio, "DD/MM/YYYY").locale(
              "pt-br"
            );
            let qtd_dias = this.selectedTipoGozo.code - 1;
            let data_f = data_i.locale("pt-br").add(qtd_dias, "days");
            this.data_fim = data_f.locale("pt-br").format("L");
          } else {
            this.data_fim = null;
          }
        }
      }
    },
    adicionarRegistro() {
      if (this.data_inicio == null) {
        this.$toast.add({
          severity: "error",
          summary: "Dados Ausentes",
          detail: "Informe a data de início",
          life: 4000,
        });
      } else {
        var programacaoAdicionada = {
          matricula: this.matricula,
          numeroVinculo: this.vinculo,
          chave: this.selectedPeriodoAquisitivo.chave,
          dataInicio: this.data_inicio,
          dataFim: this.data_fim,
          qtdDiasAfastamento: this.selectedTipoGozo.code,
          nomeServidor: this.nomeServidor,
          nomeSetor: this.nomeUnidade,
        };

        this.$http
          .post(
            `${baseApiUrl}/feriasview`,
            JSON.stringify(programacaoAdicionada)
          )
          .then(() => {
            this.$toast.add({
              severity: "success",
              summary: "Registro Adicionado com Sucesso!",
              life: 3000,
            });
            this.selectedTipoGozo.code = null;
            this.limparDados();
            this.carregarDados();
          });
      }
    },
    atualizarRegistro() {
      if (this.data_inicio == null) {
        this.$toast.add({
          severity: "error",
          summary: "Dados Ausentes",
          detail: "Informe a data de início",
          life: 4000,
        });
      } else {
        var programacaoAdicionada = {
          matricula: this.matricula,
          numeroVinculo: this.vinculo,
          chave: this.selectedPeriodoAquisitivo.chave,
          idReg: this.selectedPeriodoAquisitivo.idReg,
          dataInicio: this.data_inicio,
          dataFim: this.data_fim,
          qtdDiasAfastamento: this.selectedTipoGozo.code,
          nomeServidor: this.nomeServidor,
          nomeSetor: this.nomeUnidade,
        };

        this.$http
          .put(
            `${baseApiUrl}/feriasview`,
            JSON.stringify(programacaoAdicionada)
          )
          .then(() => {
            this.$toast.add({
              severity: "success",
              summary:
                "Pedido alterado com sucesso! Procure sua chefia para obter a aprovação.",
              life: 3000,
            });
            this.selectedTipoGozo.code = null;
            this.cancelarAlteracao();
          });
      }
    },
    abrirEdicaoFerias() {
      this.fecharModalAlteracao();
      this.$http
        .get(
          `${baseApiUrl}/feriasview/recalculaPeriodoParaEdicao/${this.matricula}/${this.vinculo}/${this.feriasSelecionado.idReg}`
        )
        .then((res) => {
          if (res.data.length > 0) {
            var v_pAquisitivo = {
              ...res.data[0],
              descPeriodo:
                res.data[0].dataInicioPeriodoAquisitivoFormat +
                " à " +
                res.data[0].dataFimPeriodoAquisitivoFormat,
            };
            let busca = this.periodosAquisitivos.filter(
              (element) => element.idReg == v_pAquisitivo.idReg
            );
            if (busca.length == 0) {
              this.periodosAquisitivos.push(v_pAquisitivo);
            }
            this.selectedPeriodoAquisitivo = v_pAquisitivo;
            this.data_inicio_agendamento =  moment().format('DD/MM/YYYY');
            this.selectedTipoGozo = null;
            this.selectedTipoGozo = {
              name: this.feriasSelecionado.totdias + " dias",
              code: this.feriasSelecionado.totdias,
            };
          }
          this.habilitarSelecaoPeriodo = false;
          this.carregarCamposAgendamento();
        });
    },
    carregarCamposAgendamento() {
      if (this.selectedPeriodoAquisitivo) {
        this.tiposGozo = [];
        this.saldoDias = this.selectedPeriodoAquisitivo.totalSaldo + " dias";
        for (var item in this.selectedPeriodoAquisitivo
          .diasPossivelAgendamento) {
          var v_tiposGozo = {
            name:
              this.selectedPeriodoAquisitivo.diasPossivelAgendamento[item]
                .dias + " dias",
            code: this.selectedPeriodoAquisitivo.diasPossivelAgendamento[item]
              .dias,
          };
          this.tiposGozo.push(v_tiposGozo);
        }
        if (this.habilitarSelecaoPeriodo) {
          this.selectedTipoGozo = null;
          this.selectedTipoGozo = this.tiposGozo[0];
        }
        // let dataPeriodo = this.selectedPeriodoAquisitivo.descPeriodo.split(' ')

        //SELECIONA O ULTIMO DIA DO ANO DA DATA DE INICIO DE AGENDAMENTO
        let dateInicioAgentamento = moment(
          this.data_inicio_agendamento,
          "DD/MM/YYYY"
        ).toDate();
        let maxDate = new moment(
          new Date(dateInicioAgentamento.getFullYear() + 2, 0, 0)
        );
        let datafimPeriodoAquisitivoSelecionado = new moment(
          this.selectedPeriodoAquisitivo.dataFimPeriodoAquisitivoFormat,
          "DD/MM/YYYY"
        );
        if (
          new moment(this.data_inicio_agendamento, "DD/MM/YYYY") <
          datafimPeriodoAquisitivoSelecionado
        ) {
          if (datafimPeriodoAquisitivoSelecionado < new moment()) {
            this.data_inicio =  moment().format('DD/MM/YYYY');
            // this.min_date = new moment('01/01/2024','DD/MM/YYYY').format()
          } else {
            this.data_inicio =
              datafimPeriodoAquisitivoSelecionado.format("DD/MM/YYYY");
            // this.min_date = datafimPeriodoAquisitivoSelecionado.format()
          }
          this.max_date = maxDate.format();
        } else {
          this.data_inicio = new moment(
            this.data_inicio_agendamento,
            "DD/MM/YYYY"
          ).format("DD/MM/YYYY");
          // this.min_date = new moment(this.data_inicio_agendamento,'DD/MM/YYYY').format()
          this.max_date = maxDate.format();
        }

        this.calcularData();
      } else {
        this.selectedTipoGozo = { name: null, code: null };
        this.tiposGozo = [];
      }
    },
    carregarDados() {
      this.bloquearLiberarAgendamento();
      this.matricula = this.$store.getters.getMatricula;
      this.vinculo = this.$store.getters.getVinculo;
      this.nomeServidor =
        this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa;
      this.nomeUnidade =
        this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap.descSetor;

      this.selectedPeriodoAquisitivo = null;
      if (
        this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor
          .length > 0
      ) {
        let vinculoAtivo = this.vinculo;
        let vinculoSelecionado =
          this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor.filter(
            function (element) {
              return element.numVinculo == vinculoAtivo;
            }
          );
        if (vinculoSelecionado.length > 0 && vinculoSelecionado[0].idenOrgao) {
          this.data_inicio_agendamento = this.data_inicio;
          this.$http
            .post(
              `${baseApiUrl}/parametro/busca`,
              JSON.stringify({
                busca: "PERMISSAO_FERIAS",
                idenSistema: process.env.VUE_APP_CODIGO_SISTEMA,
              })
            )
            .then((res2) => {
              if (res2.data.totalElements > 0) {
                this.parametro = res2.data.content[0];
                this.$http
                  .get(
                    `${baseApiUrl}/parametro/orgao/${res2.data.content[0].idenParametro}/${vinculoSelecionado[0].codgSeap}`
                  )
                  .then((res3) => {
                    if (
                      (res3.data && res3.data.valorParametro == "HABILITADO") ||
                      (!res3.data &&
                        res2.data.content[0].valorParametro == "HABILITADO")
                    ) {
                      this.$http
                        .get(
                          `${baseApiUrl}/feriasview/listaperidoaquisitivo/${this.matricula}/${this.vinculo}`
                        )
                        .then((res) => {
                          this.periodosAquisitivos = [];
                          for (var item in res.data) {
                            var v_pAquisitivo = {
                              ...res.data[item],
                              descPeriodo:
                                res.data[item]
                                  .dataInicioPeriodoAquisitivoFormat +
                                " à " +
                                res.data[item].dataFimPeriodoAquisitivoFormat,
                            };
                            this.periodosAquisitivos.push(v_pAquisitivo);
                          }
                          this.habilitaAgendamento = true;
                        });
                    }
                  });
              }
            });
        }
      }
      this.carregarDadosAgendamento();     
    },
    async bloquearLiberarAgendamento(){
      //redmine #22247
      var res = await this.$http.get(`${baseApiUrl}/feriasview/bloquearLiberarVinculo/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}`);
      this.descVinculo = res.data.descTipoVinc;
      this.bloqueiaAgendamento = res.data.situacao;
    },

    async carregarDadosAgendamento() {
      var v_agendamentos = await this.$http.get(
        `${baseApiUrl}/feriasview/${this.matricula}/${this.vinculo}`
      );
      if (v_agendamentos.status == 200) {
        this.agendamentos = [];
        this.totalRecords = v_agendamentos.data.length;
        for (var item in v_agendamentos.data) {
          if (
            !v_agendamentos.data[item].aprovador ||
            v_agendamentos.data[item].aprovador.indexOf("},{") == -1
          ) {
            let aprovador = JSON.parse(v_agendamentos.data[item].aprovador);
            var v_programacao = {
              ...v_agendamentos.data[item],
              periodoAquisitivo: v_agendamentos.data[item]
                .dataInicioDireitoAfastamento
                ? v_agendamentos.data[item].dataInicioDireitoAfastamento +
                  " à " +
                  v_agendamentos.data[item].dataFimDireitoAfastamento
                : "Não Informado",
              aprovadorLabel: aprovador
                ? aprovador.nome
                : v_agendamentos.data[item].origem == "SEAP"
                ? "DADOS INSERIDOS OU ALTERADOS PELO RH"
                : "Não Informado",
              aprovadorUnidade: aprovador ? aprovador.setor : "",
            };
            this.agendamentos.push(v_programacao);
          } else {
            let aprovador = JSON.parse(
              "[" + v_agendamentos.data[item].aprovador + "]"
            );
            var v_programacaoCompleto = {
              ...v_agendamentos.data[item],
              periodoAquisitivo: v_agendamentos.data[item]
                .dataInicioDireitoAfastamento
                ? v_agendamentos.data[item].dataInicioDireitoAfastamento +
                  " à " +
                  v_agendamentos.data[item].dataFimDireitoAfastamento
                : "Não Informado",
              aprovadorLabel:
                aprovador.length > 0
                  ? aprovador[aprovador.length - 1].nome
                  : v_agendamentos.data[item].origem == "SEAP"
                  ? "DADOS INSERIDOS OU ALTERADOS PELO RH"
                  : "Não Informado",
              aprovadorUnidade:
                aprovador.length > 0
                  ? aprovador[aprovador.length - 1].setor
                  : "",
            };
            this.agendamentos.push(v_programacaoCompleto);
          }
        }
      }
    },
    showModalJustificativa(linha) {
      let justificativa = linha.obs;
      if (linha.observacaoTemporaria) {
        justificativa =
          justificativa +
          "<br><br><strong>JUSTIFICATIVA DA ALTERAÇÃO DE DATA NEGADA:</strong><br><br>" +
          linha.observacaoTemporaria;
      }
      if (justificativa) {
        this.justificativaSelecionada = justificativa;
        this.exibirTelJustificativa = true;
      } else {
        this.$toast.add({
          severity: "error",
          summary: "justificativa Não Cadastrada",
          life: 3000,
        });
      }
    },
    showModalTermo(ferias) {
      this.feriasSelecionado = ferias;
      if (this.termo == "") {
        this.$http
          .get(`${baseApiUrl}/termosgeral/buscartermossistema`)
          .then((res2) => {
            if (res2.data.length > 0) {
              for (var i = 0; i < res2.data.length; i++) {
                if (res2.data[i].statTermo == "ATIVO") {
                  this.termo = res2.data[i].infoTermo;
                  break;
                }
              }
            }
            this.exibirTelTermo = true;
          });
      } else {
        this.exibirTelTermo = true;
      }
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>
<style scoped>
.containerTermo {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}
.textoTermo {
  text-align: justify;
  border: 1px solid gray;
  padding: 20px;
  width: 100%;
}
.containerButtonTermo {
  display: flex;
  flex-direction: row;
  padding-top: 10px;
}
.dashboard > div {
  padding: 1em;
}
.dashboard .dashboard-grid {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding: 0;
}
.dashboard .card {
  height: 100%;
  margin-bottom: 0;
}
.p-text-center {
  text-align: center;
}
.dashboard .summary-box {
  position: relative;
}
.dashboard .summary-box .card {
  min-height: 100px;
}
.dashboard .summary-box .summary-box-title {
  font-size: 2em;
  margin: 0;
  color: #ffffff;
}
.dashboard .summary-box p {
  margin: 0.25em 0;
  color: #ffffff;
}
.dashboard .summary-box .summary-box-icon {
  position: absolute;
  font-size: 5em;
  right: 24px;
  top: 32px;
}
.dashboard .summary-box .summary-box-graph {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.dashboard .summary-box.summary-box-azul .card {
  border-top: 4px solid #0097a7;
  background-color: #00bcd4;
}
.dashboard .summary-box.summary-box-azul .ico {
  color: #0097a7;
}
.dashboard .summary-box.summary-box-rosa .card {
  border-top: 4px solid #ad1457;
  background-color: #e91e63;
}
.dashboard .summary-box.summary-box-rosa .ico {
  color: #ad1457;
}
.dashboard .summary-box.summary-box-amarelo .card {
  border-top: 4px solid #f47b08;
  background-color: #ffb300;
}
.dashboard .summary-box.summary-box-amarelo .ico {
  color: #f47b08;
}
.dashboard .summary-box.summary-box-cinza .card {
  border-top: 4px solid #455a64;
  background-color: #607d8b;
}
.dashboard .summary-box.summary-box-cinza .ico {
  color: #455a64;
}
.margimLeft {
  margin-left: 5px;
}

/* STATUS DA PROGRAMAÇÃO
    APROVADO
    PENDENTE
    REPROVADO
    VALIDADO
    PUBLICADO
    */
.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.status-APROVADO {
  background-color: #c8e6c9;
  color: #256029;
}

.status-APROVADO:active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADO:hover {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADO:focus {
  box-shadow: 0 0 0 0.2rem #c8e6c9;
}
.status-VIASEAP {
  background-color: #b4b3af;
  color: #3f3e3d;
}

.status-VIASEAP:active {
  background-color: #b4b3af !important;
  color: #3f3e3d !important;
}

.status-VIASEAP:hover {
  background-color: #b4b3af !important;
  color: #3f3e3d !important;
}

.status-VIASEAP:focus {
  box-shadow: 0 0 0 0.2rem #b4b3af;
}

.status-REPROVADO {
  background-color: #ffcdd2;
  color: #c63737;
}

.status-REPROVADO:active {
  background-color: #ffcdd2 !important;
  color: #c63737 !important;
}

.status-REPROVADO:hover {
  background-color: #ffcdd2 !important;
  color: #c63737 !important;
}

.status-REPROVADO:focus {
  box-shadow: 0 0 0 0.2rem #ffcdd2;
}

.status-PENDENTE {
  background-color: #feedaf;
  color: #8a5340;
}

.status-PENDENTE:active {
  background-color: #feedaf !important;
  color: #8a5340 !important;
}

.status-PENDENTE:hover {
  background-color: #feedaf !important;
  color: #8a5340 !important;
}

.status-PENDENTE:focus {
  box-shadow: 0 0 0 0.2rem #feedaf;
}

.status-PUBLICADO {
  background-color: #b3e5fc;
  color: #23547b;
}

.status-PUBLICADO:active {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-PUBLICADO:hover {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-PUBLICADO:focus {
  box-shadow: 0 0 0 0.2rem #b3e5fc;
}
.status-FINALIZADO {
  background-color: #b3e5fc;
  color: #23547b;
}

.status-FINALIZADO:active {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-FINALIZADO:hover {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-FINALIZADO:focus {
  box-shadow: 0 0 0 0.2rem #b3e5fc;
}

.status-VALIDADO {
  background-color: #eccfff;
  color: #694382;
}

.status-VALIDADO:active {
  background-color: #eccfff !important;
  color: #694382 !important;
}

.status-VALIDADO:hover {
  background-color: #eccfff !important;
  color: #694382 !important;
}

.status-VALIDADO:focus {
  box-shadow: 0 0 0 0.2rem #eccfff;
}

.status-proposal {
  background-color: #ffd8b2;
  color: #805b36;
}

/* status 
        .status-Usufruido {
            font-weight: bold;
            color: #23547B;
        }
        .status-Agendado {
            font-weight: bold;
            color: #256029;
        }
        .status-Aguardando {
            font-weight: bold;
            color: yellowgreen;
        }*/
</style>

<style>
.situacaoColunaFeriasAgendamento > div {
  justify-content: center;
}
.botaoColunaSituacaoFeriasAgendamento {
  text-align: center !important;
}
</style>